












import Vue from 'vue';

export default Vue.extend({
  name: 'Preview',
  props: {
    title: String,
    source: String,
    autoplay: Boolean,
    loop: Boolean
  },
  // data: function () {
  //   return {
  //     video: ''
  //   };
  // },
  methods: {}
});
